module.exports = __webpack_public_path__ + "img/arrow-grey.dc5d32f2.svg";